import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { AICoachingReportTrainingPlanDto } from './ai-coaching-report-training-plan.dto';

@Api('api/app/coaching-and-training')
export class AICoachingReportDto extends DtoHasApi {
  id: number;
  conversationCount: number;
  targetConversationCount: number;
  positiveFeedbacks: string;
  negativeFeedbacks: string;
  improvementAreas: string;
  improvementAreasComparison?: string;
  progressSummary?: string;
  error: string;
  creationTime: Date;
  userId: string;
  periodId: number;
  trainingPlans: AICoachingReportTrainingPlanDto[];
  conversationIds: number[];
}
